import contextBasedEnvironment from "./contextBasedEnvironment";

/**
 * Checks uri for environment and returns a value based on environment
 *
 * @param contextValues map of {[contextBasedEnvironments] : 'Context Based Value'}
 * @return {*}
 */
export default contextValues => contextValues[contextBasedEnvironment()];
